// extracted by mini-css-extract-plugin
export default {"wrapper":"styles___wrapper___38wVx","success-placement":"styles___success-placement___1vXuL","hidden":"styles___hidden___n2G4F","success":"styles___success___igy-I"};